import { styled } from "@mui/material";
import Typography from "components/Typography";

export const Container = styled("div")({
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
});

export const MessageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(0.75),
  maxWidth: "640px",
}));

export const TitleText = styled(Typography)({
  textAlign: "center",
});

export const DescriptionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[120],
  textAlign: "center",
}));

export const LogoContainer = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(2),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const LogoImg = styled("img")({
  height: "100%",
  maxHeight: "64px",
  minHeight: "48px",
});
